import { render, staticRenderFns } from "./PhotoModal.vue?vue&type=template&id=4f82a518&scoped=true&"
import script from "./PhotoModal.vue?vue&type=script&lang=ts&"
export * from "./PhotoModal.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoModal.vue?vue&type=style&index=0&id=4f82a518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f82a518",
  null
  
)

component.options.__file = "PhotoModal.vue"
export default component.exports